// extracted by mini-css-extract-plugin
export default {"container":"ActivitiesDetailsTable_container__Rob8V","tableContainer":"ActivitiesDetailsTable_tableContainer__rkh-M"};